import datos from "src/services/datos";

export const postContenidos = async (contenidos) => {
  const { id, id_cajas, id_tipo_contenidos, meta_datos,lote } = contenidos;
  var metaDatosFiltrado = meta_datos.filter(
    (item) =>
      item.valor !== undefined && item.valor !== "" && item.valor !== null
  );

  const data = {
    id: id,
    id_cajas: id_cajas,
    id_tipo_contenidos: id_tipo_contenidos,
    meta_datos: metaDatosFiltrado,
    lote: lote ? lote : "1"
  };

  const contenidosInsert = new datos("contenidos");
  const response = await contenidosInsert.contenidosCreate(data);

  return response;
};

/**
 * Envía todos los contenidos en una sola request al endpoint bulk.
 * El servidor los procesa en una única transacción DB con SAVEPOINTs por fila,
 * evitando deadlocks en comprobantes y reduciendo drásticamente el tiempo de importación.
 */
export const postContenidosBulk = async (contenidosArray) => {
  const payload = contenidosArray.map(({ id, id_cajas, crear_caja, id_tipo_cajas, id_cuentas_localizaciones, id_tipo_contenidos, meta_datos, lote }) => ({
    id,
    id_cajas,
    crear_caja,
    id_tipo_cajas,
    id_cuentas_localizaciones,
    id_tipo_contenidos,
    meta_datos: meta_datos.filter(m => m.valor !== undefined && m.valor !== "" && m.valor !== null),
    lote: lote || "1",
  }));

  const svc = new datos("contenidos");
  return svc.contenidosBulkCreate(payload);
};

export default postContenidosBulk;